'use client';
import { twMerge } from "tailwind-merge";
import { socialIcons, socialsTypeMap } from "./svg/socials/SocialsIcons";
import Link from "next/link";
import { useCallback, useEffect, useRef, useState } from "react";
import Collapse from "./svg/socials/Collapse";
import { isBrowser } from '../../utils/isBrowser';
import { usePathname } from 'next/navigation';
import { IGeneralSettings } from '../../models/IGeneralSettings';


interface Props {
  className?: string;
  data: IGeneralSettings['socials'];
  locale: string;
}
export default function NavSocials({ className, data, locale }: Props) {
  const [{ render, show, collapsed, scrollY }, setState] = useState({render: false, show: true, collapsed: false, scrollY: 0 });
  const path = usePathname();


  const icons = Object.values(socialIcons).filter(x => data.find(y => y.type === socialsTypeMap[x.type]));

  const handleNavigation = useCallback(
    (e: any) => {
      const postMedia = document.querySelector<HTMLElement>('.post-media');
      const postsSocials = document.querySelector<HTMLElement>('.share-posts');
      if (postsSocials && postMedia) {
        const rect = postMedia.getBoundingClientRect();
        const isInView = (
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );

        if (isInView && postsSocials.classList.contains('fixed')) postsSocials?.classList.remove('fixed', 'top-[71px]');
        else if (!isInView && !postsSocials.classList.contains('fixed')) postsSocials?.classList.add('fixed', 'top-[71px]');
      }
      const w = e.currentTarget;
      const show = scrollY > w.scrollY;
      setState(prevState => ({ ...prevState, scrollY: w.scrollY, show }));
    }, [scrollY]
  );

  useEffect(() => {
    setState(prevState => ({ ...prevState, scrollY: window.scrollY, render: true}));
    window.addEventListener("scroll", handleNavigation);

    return () => {
      window.removeEventListener("scroll", handleNavigation);
    };
  }, [handleNavigation]);

  if (path.split('?')[0].endsWith('/search')) return null;

  if (!render) return null;
  return (
    <div className={twMerge('desktop:flex nav-socials hidden rtl:desktop:left-[calc((100vw-1296px)/2)] desktop:h-[50px] fixed rtl:left-0 top-[71px] z-10 bg-white items-center self-end ml-[2.5vw] desktop:ml-[12px] ltr:ml-0 ltr:mr-[2.5vw] desktop:ltr:mr-[12px] rounded-br-[20px] rounded-bl-[20px] gap-x-[20px] px-[15px] w-fit dark:bg-night-100 [&>*]:place-items-center  [&>*]:h-[42px] [&>*]:w-[42px] [&>*]:grid transition-all translate-y-0', !show && 'translate-y-[-100%]', className)}>
      <Collapse className={twMerge('cursor-pointer ltr:rotate-180', collapsed && 'rotate-180 ltr:rotate-0')} onClick={() => setState(prevState => ({ ...prevState, collapsed: !collapsed }))} />
      {icons.slice(0, collapsed ? 3 : undefined).map(({ Component, href, type }, i) => {
        return (
          <Link
            hrefLang={locale}
            title={type}
            key={type}
            rel='noopener noreferrer'
            target='_blank'
            href={(() => {
              const typeNum = Number(socialsTypeMap[type]);
              const url = data.find(x => x.type === typeNum)?.url || '';
              return url;
            })()}
          >
            <Component className='h-full w-full' />
          </Link>
        )
      }
      )}
    </div>
  )
}